module.exports = __webpack_public_path__ + "img/userheader.773dd993.svg";